import type { ElementRef } from '@angular/core';

import type { LoggerService } from 'src/app/core/services/logger/logger.service';

export interface ScriptParams {
  scriptUrl: string;
  integrity?: string;
  crossOrigin?: string;
  async?: boolean;
  isModule?: boolean;
}

export interface LoadExternalScript extends ScriptParams {
  onload?(this: void): void;
  onerror?(this: void): void;
}

export function loadExternalScript(
  loadObject: LoadExternalScript,
  target: ElementRef<Element> | null,
  doc: Document,
  log: LoggerService
): void {
  if (!loadObject?.scriptUrl) {
    log.warn('no defined scriptUrl');
    return;
  }

  const node = doc.createElement('script');
  node.type = 'text/javascript';
  if (typeof loadObject.onload === 'function') {
    node.addEventListener('load', loadObject.onload);
  }
  if (loadObject.onerror) {
    node.addEventListener('error', loadObject.onerror);
  }
  if (loadObject.integrity) {
    node.integrity = loadObject.integrity;
  }
  if (loadObject.crossOrigin) {
    node.crossOrigin = loadObject.crossOrigin;
  }
  if (loadObject.async) {
    node.async = loadObject.async;
  }
  if (loadObject.isModule) {
    node.type = 'module';
  }
  node.src = loadObject.scriptUrl;

  if (target) {
    target.nativeElement.append(node);
  } else {
    doc.querySelector('head')?.append(node);
  }
}
